import { FC, memo } from 'react';
import { Tooltip } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { RANGE_PRESENT } from './constants';
import { RangeValue } from '../../../hooks/components/useOutgoingCalls/types';
import styles from './style.module.css';
import { JournalActionButtons } from '../JournalActionButtons/JournalActionButtons';
import { JournalSearchInput } from './JournalSearchInput';
import {
  ResettableRangePicker,
  ResettableRangeValue,
} from '../../shared/ResettableRangePicker/ResettableRangePicker';

interface Props {
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRangePicker: (values: RangeValue<Dayjs>, formatString: string[]) => void;
  onOkReport: () => void;
  onToggleFilters: () => void;
  isFiltersOpen: boolean;
  isReportLoading?: boolean;
  activeFilterCount?: number;
  dateRange?: ResettableRangeValue;
  disabled?: boolean;
}

export const CallsTop: FC<Props> = memo(
  ({
    onSearch,
    onRangePicker,
    onOkReport,
    onToggleFilters,
    isFiltersOpen,
    isReportLoading,
    activeFilterCount = 0,
    dateRange = [dayjs(), dayjs()],
    disabled = false,
  }: Props) => {
    return (
      <>
        <div className={styles.callsTop}>
          <JournalSearchInput onSearch={onSearch} disabled={disabled} />
          <Tooltip title="Период заданий">
            <div className={styles.dateInputTooltipTarget}>
              <ResettableRangePicker
                className={styles.dateInput}
                value={dateRange}
                placeholder={['Период звонков', 'Период звонков']}
                presets={RANGE_PRESENT}
                onChange={onRangePicker}
                disabled={disabled}
              />
            </div>
          </Tooltip>

          <JournalActionButtons
            onReport={onOkReport}
            onToggleFilters={onToggleFilters}
            isFiltersOpen={isFiltersOpen}
            isReportLoading={isReportLoading}
            activeFilterCount={activeFilterCount}
            disabled={disabled}
          />
        </div>
      </>
    );
  },
);

CallsTop.displayName = 'CallsTop';
